/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Wie_GeeftInputs */

const nl_planning_rooster_wie_geeft = /** @type {(inputs: Planning_Rooster_Wie_GeeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie geeft de les?`)
};

/**

* @param {Planning_Rooster_Wie_GeeftInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_wie_geeft = /** @type {((inputs?: Planning_Rooster_Wie_GeeftInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Wie_GeeftInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_wie_geeft(inputs)
});
export { planning_rooster_wie_geeft as "planning.rooster.wie_geeft" }